import {readNativeAiSceneRequest} from './ai-scene-request';
import type {NativeWorkScope} from './native-envelope';

export type NativeAiSceneModifyRequest = {
  requestId: string;
  scope: NativeWorkScope;
  expectedRevision: string;
  mode: 'modify';
  prompt: string;
};

/** The saved work, never a client-supplied document, supplies the modification context. */
export function readNativeAiSceneModifyRequest(raw: unknown): NativeAiSceneModifyRequest {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) throw Error('장면 수정 요청을 확인해 주세요.');
  const value = raw as Record<string, unknown>;
  if (value.mode !== 'modify' || Object.keys(value).some(key => !['requestId', 'scope', 'expectedRevision', 'mode', 'prompt'].includes(key))) {
    throw Error('장면 수정 요청의 내용과 범위를 확인해 주세요.');
  }
  const base = readNativeAiSceneRequest({...value, mode: 'generate'});
  return {requestId: base.requestId, scope: base.scope, expectedRevision: base.expectedRevision, mode: 'modify', prompt: base.prompt};
}
